import styled from "styled-components";

const TableWrapper = styled.div`
  td:nth-child(2) {
    text-align: left;
    padding-left: 6px;
  }
`;

export default TableWrapper;
